/**
 * クッキーのキーを表します。
 */
export class N511SessionStorageKey {
  
  public static readonly N511HAISORUTOHYOUJI: string = 'N511HAISORUTOHYOUJI';
  public static readonly N511HAISORUTOHIDDEN: string = 'N511HAISORUTOHIDDEN';

  public static readonly N511APISHIYOKAHIFURAGU: string = 'N511APISHIYOKAHIFURAGU';
  public static readonly N511SAIDAISENTAKUSU: string = 'N511SAIDAISENTAKUSU';

}



// WEBPACK FOOTER //
// ./src/app/modules/n511/n511-session-storage-key.ts